// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"411a4ebf","437":"d934c575","996":"47b1fd81"}[chunkId] + ".chunk.js";
};